module.exports = __webpack_public_path__ + "static/media/19ESCAP9.485b250f.jpg";